<template>
  <div class="destinations">
    <span>&nbsp;{{ $t("editor.FIELD_DESTINATION") }}:&nbsp;</span>
    <select v-model="dest" @change="onChange($event)">
      <option
        v-for="option in destOptions"
        v-bind:value="option.value"
        v-bind:key="option.value"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
import profileService from "../services/profileService";

export default {
  props: ["value"],
  data: function () {
    return {
      dest: this.value,
      destOptions: []
    };
  },
  methods: {
    onChange() {
      this.$emit("input", this.dest);
    },

    getDefaultDestination() {
      return this.getProfileService().getDefaultDestination();
    },

    getProfileService() {
      return new profileService({
        profile: this.profile,
        user: this.user
      });
    }
  },
  mounted: function () {
    // clear destinations
    this.destOptions.length = 0;

    this.user = this.$store.getters.user;
    this.profile = this.$store.getters.profile;

    // calculate new destinations based on the profile
    this.getProfileService().processDestinations((k, dest) => {
      this.destOptions.push({
        value: k,
        text: dest.name
      });
    });

    if (this.dest === undefined || !this.dest) {
      this.dest = this.getDefaultDestination();
    }
  }
};
</script>

<style scoped>
div.destinations {
  display: inline;
}
</style>
